// removed by extract-text-webpack-plugin
module.exports = {"visibleOnMobileLayout":"ModalInMobile-example__visibleOnMobileLayout__U34-w"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ModalInMobile/ModalInMobile.example.css
// module id = 2444
// module chunks = 0